import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";
import { preserveMathCursorPosition } from "@/components/tiptap/utils/preserveMathCursorPosition";

import { appendBlock } from "../create-blocks/utils/appendBlock";
import { getCollapsedButtonProps } from "../getCollapsedButtonProps";

import type { DocumentModel } from "@/models/DocumentModel";

type Props = {
  doc: DocumentModel;
  isCollapsed?: boolean;
};

export const BlockquoteButton = observer(function BlockquoteButton({ doc, isCollapsed }: Props) {
  const t = useTranslations("sidebar.createBlocks");
  const { tiptap, editorState } = doc.editor;

  if (!tiptap) {
    return null;
  }

  const handleOnClick = () => {
    if (editorState.isNonConvertableBlock && !editorState.isImage) {
      appendBlock(doc, "blockquote");
      return;
    }

    preserveMathCursorPosition(doc, () => {
      let chain = tiptap.chain().unsetCallout();
      // If in taskList, convert it to blockquote
      if (editorState.isTaskList) {
        chain = chain.toggleTaskList();
      }
      chain.toggleBlockquote().run();
    });
  };

  return (
    <Sidebar.Button
      data-testid="quote-block-type"
      icon={<Icon name="block-format/Blockquote" />}
      title={t("blockquote.title")}
      onClick={handleOnClick}
      isActive={editorState.isBlockquote}
      aria-pressed={editorState.isBlockquote}
      inverted
      {...getCollapsedButtonProps(isCollapsed)}
    />
  );
});
